import axios from '@/services/axios';

// 技术分析
export const GetTechTrendsApi = (setting) =>
  axios.post(`/pub/v1/GetTechTrends`, { searchSetting: setting });
// 技术分析
export const GetTechTrendsApiv2 = (setting) =>
  axios.post(`/pub/v1/GetTechTrendsv2`, { searchSetting: setting });

// 研究热点
export const GetHotKeywords = (setting) =>
  axios.post(`/pub/v1/GetHotKeywords`, { searchSetting: setting });

// 研究热点
export const GetHotKeywordsv2 = (setting) =>
  axios.post(`/pub/v1/GetHotKeywordsv2`, { searchSetting: setting });

// 研究趋势技术主题
export const GetTechThemeApi = (setting) =>
  axios.post(`/pub/v1/GetTechTheme`, { searchSetting: setting });

//   关联技术-技术交叉分析
export const GetTechKeywordCrossAnalysisApi = (setting) =>
  axios.post(`/pub/v1/GetTechKeywordCrossAnalysis`, { searchSetting: setting, size: 10 });

//   关联技术-技术交叉分析-韦恩图
export const VennApi = (setting) =>
  axios.post(`/pub/v1/GetTechKeywordCrossAnalysisVenn`, { searchSetting: setting });

// 领先学者-top学者合作网络
export const GetTechTopCoNetworkApi = (
  setting,
  otherReq = {},
): Promise<Res.GetTechTopCoNetworkApi> =>
  axios.post(`/pub/v1/GetTechTopCoNetwork`, {
    searchSetting: setting,
    size: 10,
    sort: 'h-index',
    ...otherReq,
  });
export const GetTechTopCoNetworkApiv2 = (
  setting,
  otherReq = {},
): Promise<Res.GetTechTopCoNetworkApi> =>
  axios.post(`/pub/v1/GetTechTopCoNetworkv2`, {
    searchSetting: setting,
    size: 10,
    sort: 'h-index',
    ...otherReq,
  });

// 通过ID获取学者列表
export const GetPersonListByIdsApi = (ids: string[]) =>
  axios.post(`/pub/v1/GetPersonListByIds`, { ids: ids });
export const GetPersonListByIdsApiv2 = (ids: string[]) =>
  axios.post(`/pub/v1/GetPersonListByIdsv2`, { ids: ids });

/**
 * 合作网络-获取地区合作网络
 * @param setting
 * @param otherReq
 * @returns
 */
export const GetTechTopCoNetworkForCountry = (
  setting: Req.SearchSetting,
  otherReq = {},
): Promise<Res.GetTechTopCoNetworkApi> =>
  axios.post(`/pub/v1/GetTechTopCoNetworkForCountry`, {
    searchSetting: setting,
    size: 10,
    ...otherReq,
  });
/**
 * 合作网络-获取机构合作网络
 * @param setting
 * @param otherReq
 * @returns
 */
export const GetTechTopCoNetworkForOrg = (
  setting: Req.SearchSetting,
  otherReq = {},
): Promise<Res.GetTechTopCoNetworkApi> =>
  axios.post(`/pub/v1/GetTechTopCoNetworkForOrg`, {
    searchSetting: setting,
    size: 10,
    ...otherReq,
  });

/**
 * 合作网络-通分析条件，机构ID获取机构论文数量及总被引量
 * @param ids
 * @returns
 */
export const GetTechOrgDataBySearcherAndOrgId = (searchSetting: Req.SearchSetting, ids: string[]) =>
  axios.post(`/pub/v1/GetTechOrgDataBySearcherAndOrgId`, { searchSetting, ids });

/**
 * 合作网络-通分析条件，地区ID获取机构论文数量及总被引量
 * @param ids
 * @returns
 */
export const GetTechCountryDataBySearcherAndCountryId = (
  searchSetting: Req.SearchSetting,
  ids: string[],
) => axios.post(`/pub/v1/GetTechCountryDataBySearcherAndCountryId`, { searchSetting, ids });

// 领先机构-机构发文分布分析
export const GetTechOrgApi = (setting) =>
  axios.post(`/pub/v1/GetTechOrg`, { searchSetting: setting, size: 50 });

export const GetTechTrendOrgApi = (setting) =>
  axios.post(`/pub/v1/GetTechTrendOrg`, { searchSetting: setting });

// 领先地区-地区发文分布分析
export const GetTechCountryApi = (setting) =>
  axios.post(`/pub/v1/GetTechCountry`, { searchSetting: setting, size: 50 });

export const GetTechCountryForAuthorsApi = (setting) =>
  axios.post(`/pub/v1/GetTechCountryForAuthors`, { searchSetting: setting, size: 50 });

export const GetTechCountryForOrgsApi = (setting) =>
  axios.post(`/pub/v1/GetTechCountryForOrgs`, { searchSetting: setting, size: 50 });

export const GetTechTrendCountryApi = (setting) =>
  axios.post(`/pub/v1/GetTechTrendCountry`, { searchSetting: setting, size: 50 });

export const GetRankCoCountryApi = (setting) =>
  axios.post(`/pub/v1/GetRankCoCountry`, { searchSetting: setting, size: 50 });

export const GetRankCoOrgApi = (setting) =>
  axios.post(`/pub/v1/GetRankCoOrg`, { searchSetting: setting, size: 50 });

export const GetRankIndexCoCountryApi = (setting) =>
  axios.post(`/pub/v1/GetRankIndexCoCountry`, { searchSetting: setting });

export const GetRankIndexCoOrgApi = (setting) =>
  axios.post(`/pub/v1/GetRankIndexCoOrg`, { searchSetting: setting });

// export const lifeCycleApi = (setting) => axios.post(`/prediction/v1/lifeCycle`, { ...setting });
export const lifeCycleApi = (setting) =>
  axios.post(`/pub/v1/GetLifeCycle`, { searchSetting: setting });
export const lifeCycleApiV2 = (setting) =>
  axios.post(`/pub/v1/GetLifeCyclev2`, { searchSetting: setting });
// 领先地区-地区发文分布分析
export const GetTechCountryApiv2 = (setting) =>
  axios.post(`/pub/v1/GetTechCountryv2`, { searchSetting: setting, size: 50 });

// v1.4.2
// @doc "领先学者-学者发文趋势分析"
// @handler GetTechTrendAuthor
// post /GetTechTrendAuthor (AnaylzeReq) returns ([]GetTechTrendsRes)

// @doc "领先学者-学者发文排行分析"
// @handler GetTechAuthor
// post /GetTechAuthor (AnaylzeReq) returns ([]GetTechTrendsRes)

// @doc "领先学者-学者合作排行分析"
// @handler GetRankCoAuthor
// post /GetRankCoAuthor (AnaylzeReq) returns ([]GetTechTrendsRes)

// @doc "领先学者-学者合作排行分析指标统计"
// @handler GetRankIndexCoAuthor
// post /GetRankIndexCoAuthor (AnaylzeReq) returns (GetRankIndexCoAuthorRes)
export const GetTechTrendAuthor = (setting: Req.SearchSetting) =>
  axios.post(`/pub/v1/GetTechTrendAuthor`, { searchSetting: setting, size: 50 });
export const GetTechAuthor = (setting: Req.SearchSetting) =>
  axios.post(`/pub/v1/GetTechAuthor`, { searchSetting: setting, size: 50 });
export const GetRankCoAuthor = (setting: Req.SearchSetting) =>
  axios.post(`/pub/v1/GetRankCoAuthor`, { searchSetting: setting, size: 50 });
export const GetRankIndexCoAuthor = (setting: Req.SearchSetting) =>
  axios.post(`/pub/v1/GetRankIndexCoAuthor`, { searchSetting: setting, size: 50 });
